module.exports = __webpack_public_path__ + "assets/img/630-tu.c9257ac3.jpg";